import { useRef, useEffect } from "react";
import PropTypes from "prop-types";
import { Header2 } from "@base-ui";
import { StyledControlPanel, Toggle, Content } from "./controlpanel.styles";
import { useOpen } from "hooks";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var ControlPanel = function ControlPanel(props) {
  var id = props.id,
    children = props.children,
    className = props.className,
    title = props.title,
    _collapsed = props._collapsed,
    width = props.width;
  var _useOpen = useOpen(!_collapsed),
    open = _useOpen.open,
    toggleOpen = _useOpen.toggleOpen;
  var prevOpen = useRef(open);
  useEffect(function () {
    prevOpen.current = open;
  }, [open]);
  return /*#__PURE__*/_jsxs(StyledControlPanel, {
    className: className,
    open: open,
    prevOpen: prevOpen.current,
    id: "".concat(id, "-controlpanel"),
    width: width,
    "aria-label": "Kontrollpanel",
    children: [/*#__PURE__*/_jsx(Header2, {
      m: "0",
      children: /*#__PURE__*/_jsx(Toggle, {
        id: id,
        open: open,
        "aria-controls": "".concat(id, "-controlpanel"),
        "aria-expanded": open,
        onClick: toggleOpen,
        children: title
      })
    }), /*#__PURE__*/_jsx(Content, {
      open: open,
      "aria-labelledby": id,
      children: children
    })]
  });
};
ControlPanel.propTypes = {
  id: PropTypes.string.isRequired,
  children: PropTypes.any.isRequired,
  title: PropTypes.string.isRequired,
  className: PropTypes.string,
  _collapsed: PropTypes.bool,
  style: PropTypes.object
};
export default ControlPanel;